import SecurityDeviceConstants from '../constants/SecurityDeviceConstants';
import AppDispatcher from '../dispatcher/AppDispatcher';

const SecurityDeviceActionCreators = {
  getSecurityDevices: () =>
    AppDispatcher.handleViewAction({
      actionType: SecurityDeviceConstants.GET_SECURITY_DEVICES,
    }),
  handleGetSecurityDevicesSuccess: (response) =>
    AppDispatcher.handleServerAction({
      actionType: SecurityDeviceConstants.GET_SECURITY_DEVICES_SUCCESS,
      data: response,
    }),
};

export default SecurityDeviceActionCreators;
